import { TextField } from '@mui/material'
import React, { useState } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import { useDispatch } from 'react-redux'
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DateAndTime from '../../features/DateAndTime'

export default function DateField(props: IBaseDynamicFormElement) {
    const { id, label, fullWidth, handleOnChange, data, placeholder, defaultValue } = props

    const dispatch = useDispatch()
    const dateAndTime = new DateAndTime()

    const returnCurrentValue = () => {
        let value: string = ""
        if (defaultValue) value = defaultValue
        if (data.value) value = data.value
        return value
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={returnCurrentValue() ? new Date(returnCurrentValue()) : null}
                onChange={(value) => {
                    handleOnChange(id, value ? dateAndTime.formatToServerStandart(value.toString()) : value)
                }}
                slots={{
                    textField: (props) => <TextField {...props} variant="outlined" fullWidth={fullWidth} />,
                }}
            />
            <p
                onClick={() => handleOnChange(id, dateAndTime.formatToServerStandart(new Date().toString()))}
                className="form-elemt-link-button-text"
            >
                Current Date
            </p>
        </LocalizationProvider>
    )
}